import get from "lodash/get";
import { fetchInfo, createOrder } from "@/api/modules/products/seattickets";
import { makeUtcDate } from "@/utilities/time";

const InfoModel = function(info) {
    this.identifier = info.productTypeIdentifier;
    this.maximumNumberOfPassengersPerItem =
        info.maximumNumberOfPassengersPerItem;
    this.maximumStartValidityDaysFromNow = info.maximumStartValidityDaysFromNow;
};

export const state = {
    info: null
};

export const mutations = {
    updateInfo: (state, payload) => {
        state.info = new InfoModel(payload);
    }
};

export const getters = {
    isEnabled: state => Boolean(state.info)
};

export const actions = {
    fetchInfo: context => {
        return fetchInfo(true)
            .then(response => {
                if (!response.ok) throw new Error(response.responseBody);
                return response.responseBody;
            })
            .then(json => {
                context.commit("updateInfo", json);
                context.commit(
                    "system/addStopProductType",
                    {
                        productType: context.state.info.identifier
                    },
                    { root: true }
                );
            });
    },
    prepareOrder: (
        context,
        { trip, seatType, seatQuantity, calculatedPriceOre }
    ) => {
        const {
            maximumStartValidityDaysFromNow,
            maximumNumberOfPassengersPerItem
        } = context.state.info;
        const serverTime = makeUtcDate(
            context.rootGetters.getServerDateAsMoment
        );
        const periodStart = makeUtcDate(serverTime)
            .add(-1, "days")
            .endOf("day");
        const periodEnd = makeUtcDate(serverTime)
            .add(maximumStartValidityDaysFromNow, "days")
            .startOf("day")
            .add(-1, "second");

        if (trip) {
            context.commit(
                "order/setDetails",
                {
                    trip,
                    calculatedPriceOre,
                    seatTypeId: get(seatType, "id", null),
                    seatProductId: get(seatType, "productId", null),
                    seatQuantity
                },
                { root: true }
            );
        }

        context.commit(
            "passenger/updatePassengers",
            {
                maximumPassengers: maximumNumberOfPassengersPerItem
            },
            { root: true }
        );
        return context.dispatch(
            "date/prepareSelectableDates",
            { periodStart, periodEnd },
            { root: true }
        );
    },
    createOrder: context => {
        const preparedDetails = context.rootGetters["order/getDetails"];

        const {
            trip,
            seatTypeId,
            seatProductId,
            seatQuantity
        } = preparedDetails;

        if (!trip)
            throw new Error("cannot create seat ticket order without a trip");

        if (!seatProductId)
            throw new Error(
                "cannot create seat ticket order without a seat product"
            );

        if (!seatTypeId)
            throw new Error(
                "cannot create seat ticket order without a seat type"
            );

        if (!seatQuantity)
            throw new Error(
                "cannot create seat ticket order without a seat quantity larger than 0"
            );

        return context
            .dispatch(
                "date/validateTripDepartureInstant",
                trip.departureInstant,
                { root: true }
            )
            .then(
                () => {
                    return createOrder(
                        trip.tripId,
                        seatProductId,
                        seatTypeId,
                        seatQuantity
                    )
                        .then(response => {
                            if (response.ok) {
                                return response.responseBody;
                            } else if (
                                response.status === 422 &&
                                response.responseBody.error ===
                                    "TicketNotSellable"
                            ) {
                                throw new Error("TicketNotSellable");
                            } else {
                                throw new Error(JSON.stringify(response));
                            }
                        })
                        .then(({ orderId, priceOre, ...details }) => {
                            context.commit("order/setOrderId", orderId, {
                                root: true
                            });
                            context.commit("order/setPriceOre", priceOre, {
                                root: true
                            });
                            context.commit(
                                "order/setDetails",
                                {
                                    ...preparedDetails,
                                    ...details
                                },
                                { root: true }
                            );
                        });
                },
                () => {
                    throw new Error("InvalidTripDepartureInstant");
                }
            );
    }
};
